import history from '../../containers/History'
import queryString from 'query-string'
import {
  clearAuthentication,
  changeAuthorizationType,
  authLogin,
  clearState,
  clearIntervalAuthenticationChecker,
} from '../../containers/Auth'
import { updatePreviousLocation, getMe, updateCurrentTeamId } from '../../store/appReducer'
import { LOGIN_ERROR_MESSAGES, DATASOURCES, AUTHORIZATION_TYPES, CLEAR_STATE } from '../../constants'
import { clearAppState } from '../../../state/reducers/app/appActions'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'LOGIN.'
export const LOGIN_REQUEST = `${PREFIX}LOGIN_REQUEST`
export const LOGIN_SUCCESS = `${PREFIX}LOGIN_SUCCESS`
export const LOGIN_FAILED = `${PREFIX}LOGIN_FAILED`
export const LOGIN_CANCELLED = `${PREFIX}LOGIN_CANCELLED`
export const UPDATE_LOGIN_ERROR = `${PREFIX}UPDATE_LOGIN_ERROR`
export const CLEAR_LOGIN_ERROR = `${PREFIX}CLEAR_LOGIN_ERROR`
export const UPDATE_LOGIN_FORM = `${PREFIX}UPDATE_LOGIN_FORM`
export const CLEAR_LOGIN_FORM = `${PREFIX}CLEAR_LOGIN_FORM`
export const LOGOUT = `${PREFIX}LOGOUT`

// ------------------------------------
// Actions
// ------------------------------------
export function requestLogin() {
  return {
    type: LOGIN_REQUEST,
  }
}
export function loginSuccess() {
  return {
    type: LOGIN_SUCCESS,
  }
}
export function loginFailed() {
  return {
    type: LOGIN_FAILED,
  }
}
export function loginCancelled() {
  return {
    type: LOGIN_CANCELLED,
  }
}
export function updateLoginError(errorMsg) {
  return {
    type: UPDATE_LOGIN_ERROR,
    payload: errorMsg,
  }
}
export function clearLoginError() {
  return {
    type: CLEAR_LOGIN_ERROR,
  }
}
export function logout() {
  return {
    type: LOGOUT,
  }
}
export function updateLoginForm(field) {
  return {
    type: UPDATE_LOGIN_FORM,
    payload: field,
  }
}
export function clearLoginForm() {
  return {
    type: CLEAR_LOGIN_FORM,
  }
}

export function clearErrorMsg() {
  return (dispatch, getState) => {
    dispatch(clearLoginError())
  }
}


export const handleChange = evt => (dispatch, getState) => {
  const field = {
    [evt.target.name]: evt.target.value,
  }
  dispatch(updateLoginForm(field))
}

export const handlePasswordKeyDown = () => (dispatch, getState) => {
  dispatch(updateLoginError(''))
  dispatch(handleLogin())
}

export function handleLogin() {
  return (dispatch, getState) => {
    dispatch(requestLogin())

    const creds = getState().login.form
    const {
      username,
      password,
    } = creds

    if (!username || !password) {
      dispatch(updateLoginError(LOGIN_ERROR_MESSAGES.BAD_CREDENTIALS))
      return dispatch(loginFailed())
    } else {
      return dispatch(authLogin(creds))
        .then(() => {
          const {
            isAuthenticated,
            authError,
          } = getState().auth
          // const isAuthenticated = dispatch(checkAuthentication())
          if (isAuthenticated) {
            return dispatch(getMe())
              .then(() => {
                const {
                  [DATASOURCES.ME]: me,
                } = getState().app.dataSources
                const {
                  currentTeamId,
                  previousLocation,
                } = getState().app

                const qsParams = queryString.parse(window.location.search)
                const isPrevRelativePath = qsParams.prev
                  ? qsParams.prev[0] === '/'
                  : false

                let nextLocation

                dispatch(clearState())
                // for new framework app store data.
                dispatch(clearAppState())
                // console.log('SomeThings happening ==> ', qsParams)
                if (currentTeamId.length !== 0 && me.data.teams[0].id !== currentTeamId) {
                  dispatch(updateCurrentTeamId(me.data.teams[0].id))
                  dispatch(changeAuthorizationType(AUTHORIZATION_TYPES.PHYSICIAN))
                } else {
                  nextLocation = previousLocation
                }

                dispatch(clearLoginForm())
                dispatch(loginSuccess())

                if (isPrevRelativePath) {
                  window.location.href = qsParams.prev
                } else if (!nextLocation) {
                  history.push('/')
                } else {
                  history.push(nextLocation)
                }
              })
          } else {
            dispatch(updateLoginError(authError))
            return dispatch(loginFailed())
          }
        })
    }
  }
}

export function handleLogout(msg, location) {
  return (dispatch, getState) => {
    dispatch(updatePreviousLocation(location))
    if (msg && msg.length > 0) {
      dispatch(updateLoginError(msg))
    }
    history.push('/login')
    clearIntervalAuthenticationChecker()
    dispatch(clearAuthentication())
    dispatch(clearState())

    // dispatch(logout());
    // dispatch(push("/login"));
    // dispatch(clearState());
    // dispatch(clearAuthentication());
    // msg.length > 0 && dispatch(updateLoginError(msg));
  }
}

const initialState = {
  loginIsFetching: false,
  form: {},
  errorMsg: '',
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LOGIN_REQUEST]: (state, action) => ({
    ...state, loginIsFetching: true,
  }),
  [LOGIN_SUCCESS]: (state, action) => ({
    ...state, loginIsFetching: false,
  }),
  [LOGIN_FAILED]: (state, action) => ({
    ...state, loginIsFetching: false,
  }),
  [UPDATE_LOGIN_FORM]: (state, action) =>
    ({ ...state, form: Object.assign({}, state.form, action.payload) }),
  [CLEAR_LOGIN_FORM]: (state, action) =>
    ({ ...state, form: {} }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
  [UPDATE_LOGIN_ERROR]: (state, action) => ({ ...state, errorMsg: action.payload }),
  [CLEAR_LOGIN_ERROR]: (state, action) => ({ ...state, errorMsg: '' }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function loginReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/Login/module.js